var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"indexbox"},[_c('nav-bar',{attrs:{"title":""}}),_c('img',{attrs:{"src":require("../../../assets/img/d.png"),"alt":""}}),_c('p',[_vm._v(_vm._s(_vm.$t('支付成功')))]),_c('p',{staticClass:"msg"},[_vm._v(_vm._s(_vm.$t('您已完成支付')))]),_c('van-button',{attrs:{"type":"default","to":"list"}},[_vm._v(_vm._s(_vm.$t('知道了')))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }